import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whyus-header',
  templateUrl: './whyus-header.component.html',
  styleUrls: ['./whyus-header.component.less']
})
export class WhyusHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
